import { Input as BaseInput } from '@base-ui/react/input';
import type * as React from 'react';
import { cn } from '@/lib/utils';

export function Input({ className, ...props }: React.ComponentProps<typeof BaseInput>) {
  return (
    <BaseInput
      className={cn(
        'flex h-9 w-full border border-mesa-border bg-transparent px-3 py-1 text-sm',
        'placeholder:text-mesa-muted',
        'focus:border-mesa-green focus:ring-2 focus:ring-mesa-green/20 focus:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}
